import { Component, OnInit } from '@angular/core';
import { ActivityView } from '../../../../../views/master-views/app.view/app.view.component';
import {
  CompleteActivityReasons,
  CompleteWorkflowActivity
} from '../../../../../models/activities';
import { ActivityUtilities, WorkflowContextService } from '../../../../../services';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-complete-workflow-activity-input',
    templateUrl: './complete-workflow-activity-input.component.html',
    styleUrls: ['./complete-workflow-activity-input.component.css'],
    standalone: false
})
export class CompleteWorkflowActivityInputComponent extends ActivityView
  implements OnInit {
  activity: CompleteWorkflowActivity;
  templateForPermitForm: boolean = false;         // Added by Vipul on 16/12/2025

  completedReason = CompleteActivityReasons.COMPLETED;
  rejectedReason = CompleteActivityReasons.REJECTED;
  incompleteReason = CompleteActivityReasons.INCOMPLETE;
  
  constructor(public layoutService: LayoutService, context : WorkflowContextService) {
    super();
    // Started by Vipul on 16/12/2025
       layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
    // End by Vipul on 16/12/2025
  }

  ngOnInit() {
    // this.showSave.emit(false);
    this.showNext.emit(true);
    // this.showPrevious.emit(false);

    if (this.activity.model.activities) {
      const activities = ActivityUtilities.convertActivitiesJsonToClasses(
        this.activity.model.activities
      );

      this.activity.model.activities = Object.keys(activities).map(
        (value: string, index: number) => activities[value]
      );
    }
  }
}
